import { gql } from '@apollo/client';
import { forPaginated } from './common/paginated.graphql';
import { Lot } from '../types/lot/lot';
import { CreateLotInput, DeleteLotInput, UpdateLotInput } from '../types/lot/lot.input';
import { CustomFieldFragment } from './customField.graphql';

const lot = gql`
  fragment Lot on Lot {
    id
    version
    companyId
    updatedAt
    updatedBy
    number
    productMasterDataId
    expirationDate
    customFields {
      ...CustomFieldValue
    }
  }
  ${CustomFieldFragment.customFieldValue}
`;

const get = gql`
  query Lots($companyId: String!, $page: Float) {
    lots(companyId: $companyId, page: $page) {
      data {
        ...Lot
      }
      page
      pageSize
      batchSize
      hasNext
    }
  }
  ${lot}
`;

export interface GetLotsVariables {
  companyId: string;
  page?: number;
}

export interface GetLotsResponse {
  lots: PaginatedLots;
}

class PaginatedLots extends forPaginated<Lot>() {}

const create = gql`
  mutation CreateLot($lots: [CreateLotInput!]!) {
    createLot(lots: $lots) {
      ...Lot
    }
  }
  ${lot}
`;

export interface CreateLotVariables {
  lots: CreateLotInput[];
}

export interface CreateLotResponse {
  createLot: Lot[];
}

const update = gql`
  mutation UpdateLot($lots: [UpdateLotInput!]!) {
    updateLot(lots: $lots) {
      ...Lot
    }
  }
  ${lot}
`;

export interface UpdateLotVariables {
  lots: UpdateLotInput[];
}

export interface UpdateLotResponse {
  updateLot: Lot[];
}

const remove = gql`
  mutation DeleteLot($lots: [DeleteLotInput!]!) {
    deleteLot(lots: $lots) {
      ...Lot
    }
  }
  ${lot}
`;

export interface DeleteLotVariables {
  lots: DeleteLotInput[];
}

export interface DeleteLotResponse {
  deleteLot: Lot[];
}

export const LotQueries = {
  get,
};

export const LotMutations = {
  create,
  update,
  remove,
};

export const LotFragments = {
  lot,
};
